import { SelectItemVm } from '@treasury/presentation/components/forms';
import { camelCaseToTitle } from '@treasury/utils/functions';

/**
 * Transfer payment statuses used by the API.
 *
 * *Note*: These lack a space that would normally be present in a user-facing string.
 * For example, `"PendingApproval"` instead of `"Pending Approval"`.
 */
export type TransferPaymentStatus =
    | 'PendingApproval'
    | 'Scheduled'
    | 'Submitted'
    | 'ApprovalRejected'
    | 'Cancelled'
    | 'Failed'
    | 'Expired';

export const transferPaymentStatuses: TransferPaymentStatus[] = [
    'PendingApproval',
    'Scheduled',
    'Submitted',
    'ApprovalRejected',
    'Cancelled',
    'Failed',
    'Expired',
];

export function mapTransferPaymentStatus(
    status: TransferPaymentStatus
): SelectItemVm<TransferPaymentStatus> {
    return {
        label: camelCaseToTitle(status),
        value: status,
    };
}
